import React from "react";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
const needs = ["A case.", "A pathway.", "A few focused questions.", "A way to organize what you see.", "A process for turning each case into a learning opportunity."];
export function FinalCTASection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-129" data-mp="1pkfr5iuaxck9">
      <div className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="1pimki3jousc9">
        <h2 className="font-serif text-[32px] font-bold leading-tight text-white sm:text-5xl" data-id="element-131" data-mp="1kkl3rp9qj53y">
          Ready to stop staring at the case… <em className="text-gold-400" data-id="element-132" data-mp="1z9qyazxmo75i">and start following a pathway?</em>
        </h2>
        <p className="mt-5 text-lg text-white/80" data-id="element-133" data-mp="1ubxw0hzg3xai">You don’t need another 20-hour lecture. You need:</p>
        <ul className="mx-auto mt-5 max-w-md space-y-2.5 text-left" data-id="element-134" data-mp="28bqfptck1d8z">
          {needs.map(n => <li key={n} className="flex items-start gap-3 text-lg text-white" data-id="element-135" data-mp="24b6iyqvw8bnd">
              <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-136" data-mp="1ho9q70ap3bpp" />
              {n}
            </li>)}
        </ul>

        <img src={images.mainMockup} alt="Blepharoplasty Clinical Pathway complete bundle" className="mx-auto mt-8 w-full max-w-lg" data-id="element-137" data-mp="1qnmqp3gucpya" />

        <p className="mt-4 font-serif text-[80px] font-extrabold leading-none text-gold-400" data-id="element-138" data-mp="1vnr7kulnvmp1">$27</p>
        <p className="mt-2 text-base text-white/80" data-id="element-139" data-mp="20kref7qc4th7">6 Premium Volumes + 5 Bonuses · Instant access · Lifetime access · 7-day guarantee</p>

        <div className="mt-7" data-id="element-140" data-mp="24lba06v9fp18">
          <CTAButton label="Get the Clinical Pathway™" data-id="element-141" data-mp="29ee88sazfmnr" />
        </div>
        <div className="mt-8" data-id="element-142" data-mp="29g7e45dru2up">
          <Countdown tone="dark" data-id="element-143" data-mp="2ecxr2jua4ibw" />
        </div>
      </div>
    </section>;
}